<!-- <ion-row>
  <ion-col size="12">
    <div class="popup-heading">
      <div>
        <p class="fs-16 fs_14ForMobile font_regular">{{employeeName}}</p>
      </div>
      <div class="popup-close">  
        <button class="download-btn" (click)="onClickDownloadLetter()" >
          <span class="ml-5 mr-5 fs-12 material-icons">arrow_downward</span>
          download
        </button>
        <span [mat-dialog-close] class="ml-35 mr-5 fs-30 material-icons popup-close-icon">close</span>
      </div>
    </div>
  </ion-col>
</ion-row>
<div class="cardLayout">
  
  <ion-row>
    <ion-col size="12">
      <div class="mt-20">
        
        
        <iframe *ngIf="letterUrl" [src]="letterUrl" width="100%" height="600px" style="border: none;"></iframe>
        
        
      </div>
    </ion-col>
  </ion-row>
</div>

-->


<div class="cardLayout">
  <ion-row>
    <ion-col size>
      <!-- <div class="popup-heading"> -->
        <div>
          <p class="fs-16 fs_14ForMobile font_regular">{{employeeName}}</p>
        </div>
      </ion-col>
      <ion-col size="auto">
        <div class="popup-close">
          <button *ngIf="!mobileResponsiveService.hideForMobile" class="download-btn" (click)="onClickDownloadLetter()">
            <span class="fs-12 fs_18ForMobile material-icons">arrow_downward</span>
            <span class="ml-5">Download</span>
          </button>
          <span [mat-dialog-close] class="ml-15 fs-24 fs_18ForMobile material-icons popup-close-icon">close</span>
        </div>
      </ion-col>
    <!-- </div> -->
  </ion-row>
  <!-- <ion-row>
    <ion-col size="12"> -->
      <mat-dialog-content class="p-0">
        <div class="iframe-container" >
          <iframe width="100%" height="100%" *ngIf="letterUrl && !mobileResponsiveService.hideForMobile" [src]="letterUrl" style="border: none;"></iframe>
          
          <button *ngIf="mobileResponsiveService.hideForMobile" class="download-btn" (click)="onClickDownloadLetter()">
            <span class="fs_18ForMobile material-icons">arrow_downward</span>
            <span class="fs-18 ml-5">Download</span>
          </button>
        </div>
      </mat-dialog-content>
    <!-- </ion-col>
  </ion-row> -->
</div>
